import { Routes } from '@angular/router';
import { authGuardFn } from './auth-guard.service';
import { applicationConfig } from '../environments/environment';

export const routes: Routes = [
    {
        path: 'registration',
        loadComponent: () => import('./registration/registration.component').then(m => m.RegistrationComponent),
    },
    {
        path: 'logout',
        redirectTo: 'login',
        runGuardsAndResolvers: 'paramsOrQueryParamsChange'
    },
    {
        path: 'home',
        loadComponent: () => import('./text-to-sql/text-to-sql.component').then(m => m.TextToSQLComponent),
        canActivate: [authGuardFn],
        data: { groups: [applicationConfig.adminGroupName, applicationConfig.nonAdminGroupName, applicationConfig.superAdminGroupName] },
    },
    {
        path: 'user',
        loadComponent: () => import('./user-management/user-management.component').then(m => m.UserManagementComponent),
        canActivate: [authGuardFn],
        data: { groups: [applicationConfig.adminGroupName, applicationConfig.nonAdminGroupName, applicationConfig.superAdminGroupName] },
    },
    {
        path: 'login',
        loadComponent: () => import('./login/login.component').then(m => m.LoginComponent),
        runGuardsAndResolvers: 'paramsOrQueryParamsChange'
    },
    { path: '', redirectTo: 'login', pathMatch: 'full' },
];